<div class="modal fade">
    <div class="modal-dialog modal-dialog-scrollable modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <ng-template [ngIf]="!editMode">
                    <h4 class="modal-title">
                        {{titleInsert}}
                    </h4>     
                    <h6 class="modal-subtitle">
                        {{subTitleInsert}}
                    </h6>                    
                </ng-template>

                <ng-template [ngIf]="editMode">
                    <h4 class="modal-title">
                        {{titleEdit}}
                    </h4>
                    <h6 class="modal-subtitle">
                        {{subTitleEdit}}
                    </h6>                    
                </ng-template>                                        
            </div>
            <div class="modal-body">
                <form #form="ngForm" novalidate>
                    <div *ngIf="entityBaixa"> 
                        <div class="row">
                            <div class="form-group col-12">
                                <label class="col-form-label" for="clienteBaixa">{{clienteInputLabel}}</label>
                                <ng-template [ngIf]="canEditCliente">
                                    <sgt-typeahead-cliente [(ngModel)]="entityBaixa.cliente" name="clienteBaixa" id="clienteBaixa"
                                        #typeaeadCliente #clienteBaixa="ngModel" [ngControl]="clienteBaixa" required="required"
                                        (entitySelected)="onSelectCliente($event)" (clearEntity)="onClearCliente()">
                                    </sgt-typeahead-cliente>
                                    <sgt-form-control-error
                                        *ngIf="clienteBaixa.errors && clienteBaixa.errors.required && clienteBaixa.dirty"
                                        msgError="O cliente é obrigatório">
                                    </sgt-form-control-error>                                                                   
                                </ng-template>

                                <ng-template [ngIf]="!canEditCliente">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                          <span class="input-group-text">{{entityBaixa?.cliente?.pessoa?.codigoIntegracaoErp}}</span>
                                        </div>
                                        <input type="text" class="form-control" [value]="entityBaixa?.cliente?.pessoa?.nome" disabled="disabled" readonly="readonly">
                                    </div>
                                    <p class="form-text text-muted" *ngIf="entityBaixa?.cliente">
                                        {{entityBaixa?.cliente?.pessoa?.nomeFantasia}} - {{entityBaixa?.cliente?.pessoa?.cnpjCpf}} - {{entityBaixa?.cliente?.pessoa?.enderecoPrincipal?.cidade?.nome}} - {{entityBaixa?.cliente?.pessoa?.enderecoPrincipal?.cidade?.estado?.uf}}
                                    </p>
                                </ng-template>                                
                            </div>
                        </div>
                        <div class="row" *ngIf="!isRepresentante">
                            <div class="form-group form-group-representante col-12">
                                <label class="col-form-label">Representante</label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                      <span class="input-group-text">{{entityBaixa?.representante?.pessoa?.codigoIntegracaoErp}}</span>
                                    </div>
                                    <input type="text" class="form-control" [value]="entityBaixa?.representante?.pessoa?.nome" disabled="disabled" readonly="readonly">
                                </div>
                                <p class="form-text text-muted" *ngIf="entityBaixa?.representante">
                                    {{entityBaixa?.representante?.pessoa?.nomeFantasia}} - {{entityBaixa?.representante?.pessoa?.cnpjCpf}}
                                </p>                                                                
                            </div>
                        </div>

                        <ng-template [ngIf]="editMode">
                            <div class="row">
                                <div class="form-group col-12 col-md-5 col-lg-3">
                                    <label class="col-form-label">Data</label>
                                    <input type="text" class="form-control" value="{{entityBaixa.dataBaixa | date: 'dd/MM/yyyy'}} às {{entityBaixa.dataBaixa | date: 'HH:mm'}}" disabled="disabled" readonly="readonly">
                                </div>
                                <div class="form-group col-12 col-md">
                                    <label class="col-form-label">Usuário</label>
                                    <input type="text" class="form-control" [value]="entityBaixa.baixaManual ? entityBaixa.nomeUsuarioBaixa : 'Automática'" disabled="disabled" readonly="readonly">
                                </div>
                            </div>
                        </ng-template>                        
                                                             
                        <div class="row">
                            <div class="form-group col-12">
                                <label for="motivoBaixaCliente" class="col-form-label">Motivo</label>
                                <textarea class="form-control" [(ngModel)]="entityBaixa.motivoBaixa" name="motivoBaixaCliente" id="motivoBaixaCliente" 
                                    #motivoBaixaCliente="ngModel" rows="10" required="required" minlength="15">
                                </textarea>
                                <sgt-form-control-error
                                    *ngIf="motivoBaixaCliente.errors && motivoBaixaCliente.errors.required && motivoBaixaCliente.dirty"
                                    msgError="O motivo é obrigatório">
                                </sgt-form-control-error>
                                <sgt-form-control-error
                                    *ngIf="motivoBaixaCliente.errors && motivoBaixaCliente.errors.minlength"
                                    msgError="O motivo deve ter no mínimo 15 caracteres">
                                </sgt-form-control-error>                                                                                               
                            </div>
                        </div>
                    </div>
                </form>                
            </div>
            <div class="modal-footer">           
                <button type="button" class="btn btn-light" (click)="cancel()">
                    <i class="fas fa-times"></i> Cancelar
                </button>
                <button type="button" class="btn btn-baixar" id="btnClienteBaixarModal" [disabled]="!form.valid" (click)="baixar()">
                    <i class="far fa-window-close"></i> {{btnBaixarText}}
                </button>                
            </div>            
        </div>
    </div>
</div>